import React from 'react';

export default function ErrorCircleIcon({
  color = 'currentColor',
  fontSize = '16px',
}) {
  return (
    <>
      <i
        className={`fas fa-times-circle`}
        style={{ color, fontSize: fontSize }}
      ></i>
    </>
  );
}
